module.exports = __webpack_public_path__ + "img/banner-page-visit-mobile.cf9a408e.png";